"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var browser_1 = __importDefault(require("@brianmcallister/highlight-text/dist/browser"));

var react_1 = __importDefault(require("react"));
/**
 * Base CSS class.
 * @private
 */


var baseClass = 'highlight-text';
/**
 * HighlightText component.
 */

exports.default = function (_ref) {
  var className = _ref.className,
      text = _ref.text,
      words = _ref.words;
  return react_1.default.createElement("div", {
    className: classnames_1.default(baseClass, className),

    /* eslint-disable-next-line react/no-danger */
    dangerouslySetInnerHTML: {
      __html: browser_1.default(text, words)
    },
    style: {
      whiteSpace: 'pre-wrap'
    }
  });
};